    import React, { useState, useEffect } from "react";
    import { Dropdown } from "primereact/dropdown";
    import { InputText } from "primereact/inputtext";
    import { Button } from "primereact/button";
    import * as Yup from "yup";
    import { useFormik } from "formik";
    import classNames from "classnames";
    import appUrl from "../../../config/appUrl";
    import { toast } from "react-toastify";

    const AddEditPrice = ({ onHide, getPriceList, addEditSite, editData  }) => {
    const [disable, setDisable] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [priceTypeOptions, setPriceTypeOptions] = useState([]);
  const isEdit = !!editData;
  console.log('editData', editData)
    const validationSchema = Yup.object().shape({
    // Common fields
   friendlyName: Yup.string()
    .required("Friendly Name is required")
    .max(100, "Friendly Name cannot exceed 100 characters"),
    vehicleType: Yup.string().required("Vehicle Type is required"),
    priceType: Yup.number().required("Price Type is required"),

    // Hourly setup 1 or 2 logic
    hourlySetup: Yup.string(),

    parkingFee: Yup.string().when(["priceType", "hourlySetup"], {
  is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup1",
  then: (schema) => schema.required("Parking Fee is required"),
  otherwise: (schema) => schema.notRequired(),
}),
parkingHours: Yup.string().when(["priceType", "hourlySetup"], {
  is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup1",
  then: (schema) => schema.required("Parking Hours is required"),
  otherwise: (schema) => schema.notRequired(),
}),

    // Setup 2 only
    initialFee: Yup.string().when(["priceType", "hourlySetup"], {
        is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup2",
        then: (schema) => schema.required("Initial fee is required for Hourly price type"),
        otherwise: (schema) => schema.notRequired(),
    }),

    initialHours: Yup.string().when(["priceType", "hourlySetup"], {
        is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup2",
        then: (schema) => schema.required("Initial hours are required for Hourly price type"),
        otherwise: (schema) => schema.notRequired(),
    }),

    recursiveFee: Yup.string().when(["priceType", "hourlySetup"], {
        is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup2",
        then: (schema) => schema.required("Recursive fee is required for Hourly price type"),
        otherwise: (schema) => schema.notRequired(),
    }),

    recursiveHours: Yup.string().when(["priceType", "hourlySetup"], {
        is: (priceType, hourlySetup) => priceType === 2 && hourlySetup === "setup2",
        then: (schema) => schema.required("Recursive hours are required for Hourly price type"),
        otherwise: (schema) => schema.notRequired(),
    }),
    });
console.log('editData', editData)

    // ✅ Fetch Vehicle Types
    const getVehicleTypes = async () => {
        try {
        const response = await fetch(`${appUrl.BASE_URL}category`);
        const data = await response.json();
        setCategoryOptions(data);
        } catch (error) {
        console.error(error);
        }
    };

    // ✅ Fetch Price Types
    const getPriceTypes = async () => {
        try {
        const response = await fetch(`${appUrl.BASE_URL}PriceSetup/getPriceTypes`);
        const result = await response.json();
        setPriceTypeOptions(result?.data);
        } catch (error) {
        console.error(error);
        }
    };

    useEffect(() => {
        getVehicleTypes();
        getPriceTypes();
    }, []);

    const formik = useFormik({
        validationSchema: validationSchema,
  initialValues: {
  friendlyName: editData?.name || "",
  vehicleType: categoryOptions.find((x) => x.name === editData?.vehicleType)?._id || "",
    priceType:priceTypeOptions.find((x) => x.name === editData?.priceType)?.id || "",
    isActive: editData?.isActive ?? true,
confirmFeeBeforeSave: editData?.confirmFeeBeforeSave ?? false,
  parkingFee: editData?.parkingFee || "",
parkingHours: editData?.parkingHours || "",
  charge: editData?.charge || "",
  everyHour: editData?.everyHour || "",
  initialFee: editData?.initialFee || "",
  initialHours: editData?.initialHours || "",
  recursiveFee: editData?.recursiveFee || "",
  recursiveHours: editData?.recursiveHours || "",
  receivedAtCheckin: editData?.receivedAtCheckin ?? false,
  receivedAtCheckinEveryHour: editData?.receivedAtCheckinEveryHour ?? false,
  initialReceivedAtCheckin: editData?.initialReceivedAtCheckin ?? true,
  recursiveReceivedAtCheckin: editData?.recursiveReceivedAtCheckin ?? false,
  onCheckInFee: editData?.onCheckInFee ?? true,
  hourlySetup: editData?.hourlySetup || "setup1",
},
 enableReinitialize: true,
   onSubmit: async (values, { resetForm }) => {
  setDisable(true);
  try {
    // Find selected price type object
    const selectedPriceTypeObj = priceTypeOptions.find(
      (x) => x.id === values.priceType
    );

    const payload = {
          Id: isEdit ? editData?.id || editData?._id : undefined, //
      Name: values.friendlyName,
      VehicleType: values.vehicleType,
      enumPriceTypeId: values.priceType,
    ConfirmFeeBeforeSave: values.confirmFeeBeforeSave,
IsActive: values.isActive,// ✅ true = Active
      CreatedBy: "65a11ecab59a0916363d09a3", // replace dynamically if needed
    };

    // 🧩 Handle Fixed / Daily / Monthly
    if ([1, 3, 4].includes(values.priceType)) {
      payload.ParkingFee = Number(values.parkingFee) || 0;
      payload.ReceiveParkingFeeAtCheckIn = values.receivedAtCheckin;
    }

    // 🧩 Handle Hourly
    if (values.priceType === 2) {
    if (values.hourlySetup === "setup1") {
  payload.ParkingFee = Number(values.parkingFee) || 0;
  payload.ParkingHours = Number(values.parkingHours) || 0;
  payload.ReceiveParkingFeeAtCheckIn = values.receivedAtCheckinEveryHour;
}else if (values.hourlySetup === "setup2") {
        payload.InitialFee = Number(values.initialFee) || 0;
        payload.InitialHours = Number(values.initialHours) || 0;
        payload.ReceiveInitialFeeAtCheckIn = values.initialReceivedAtCheckin;

        payload.RecursiveFee = Number(values.recursiveFee) || 0;
        payload.RecursiveHours = Number(values.recursiveHours) || 0;
        payload.ReceiveRecursiveFeeAtCheckIn = values.recursiveReceivedAtCheckin;
      }
    }

    // API URL + METHOD
    const url = isEdit
      ? `${appUrl.BASE_URL}PriceSetup/update`
      : `${appUrl.BASE_URL}PriceSetup/add`;
    const method = isEdit ? "POST" : "POST";

    // 🧠 API CALL
    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (response.ok && result?.success !== false) {
      toast.success(result?.message || "Price saved successfully ✅", {
        position: "top-right",
        autoClose: 2000,
      });
      resetForm();
      onHide();
      getPriceList && (await getPriceList());
    } else {
      toast.error(result?.msg || result?.message || "Failed to save ❌", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  } catch (error) {
    console.error("API Error:", error);
    toast.error("Something went wrong! ❌", {
      position: "top-right",
      autoClose: 3000,
    });
  } finally {
    setDisable(false);
  }
}})

useEffect(() => {
  if (isEdit && editData && categoryOptions.length > 0 && priceTypeOptions.length > 0) {
  const matchedVehicle =
      categoryOptions.find(
        (x) =>
          x._id === editData.vehicleType ||
          x.name === editData.vehicleType?.name ||
          x.name === editData.vehicleType
      )?._id;
    const matchedPriceType = priceTypeOptions.find(
      (x) => x.id === editData.enumPriceTypeId
    )?.id;

    formik.setValues({
      ...formik.values,
      friendlyName: editData.name || "",
      vehicleType: matchedVehicle || "",
      priceType: matchedPriceType || "",
      isActive: editData.isActive ?? true,
      confirmFeeBeforeSave: editData.confirmFeeBeforeSave ?? false,
      parkingFee: editData.parkingFee || "",
      charge: editData.recursiveFee || "",
      everyHour: editData.recursiveHours || "",
      initialFee: editData.initialFee || "",
      initialHours: editData.initialHours || "",
      recursiveFee: editData.recursiveFee || "",
      recursiveHours: editData.recursiveHours || "",
      hourlySetup:
        editData.initialFee != null || editData.initialHours != null
          ? "setup2"
          : "setup1",
    });
  }
}, [categoryOptions, priceTypeOptions, editData]);


    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) =>
        isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
        );

    const selectedPriceType = formik.values.priceType;

    return (
        <>
        <h5>{addEditSite ? "Edit Price Configuration" : "Add Price Configuration"}</h5>

        <div className="brdr__top">
            <form onSubmit={formik.handleSubmit}>
            <div className="">
                <div className="p-fluid formgrid grid">

                {/* Friendly Name */}
                <div className="field col-12 md:col-6">
                    <label><b>Friendly Name </b></label>
                    <span style={{ color: "red" }}>*</span>
                    <InputText
    name="friendlyName"
    value={formik.values.friendlyName}
    onChange={(e) => {
        // Sirf alphabets aur spaces allow karo, max 100 characters
        const value = e.target.value
            .replace(/[0-9]/g, "") // Numeric remove kar do
            .slice(0, 100); // Max 100 chars
        formik.setFieldValue("friendlyName", value);
    }}
    className={classNames({
        "p-invalid": isFormFieldValid("friendlyName"),
    })}
    placeholder="Enter Friendly Name"
/>
                    {getFormErrorMessage("friendlyName")}
                </div>

                {/* Vehicle Type */}
                <div className="field col-12 md:col-6">
                    <label><b>Vehicle Type </b></label>
                    <span style={{ color: "red" }}>*</span>
                    <Dropdown
                    name="vehicleType"
                    value={formik.values.vehicleType}
                    onChange={(e) => formik.setFieldValue("vehicleType", e.value)}
                    options={categoryOptions}
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="Select Vehicle Type"
                    className={classNames({
                        "p-invalid": isFormFieldValid("vehicleType"),
                    })}
                    />
                    {getFormErrorMessage("vehicleType")}
                </div>

                {/* Price Type */}
                <div className="field col-12 md:col-6">
                    <label><b>Price Type </b></label>
                    <span style={{ color: "red" }}>*</span>
                    <Dropdown
                    name="priceType"
                    value={formik.values.priceType}
               onChange={(e) => formik.setFieldValue("priceType", e.value)}
                    options={priceTypeOptions}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Price Type"
                    />
                    {getFormErrorMessage("priceType")}
                </div>

                {/* Active / Confirm Fee */}
               <div className="field col-12 md:col-6">
  <label><b>Status & Confirmation</b></label>
  <div className="flex align-items-center">
    <div className="mr-3">
      <input
        type="checkbox"
        id="isActive"
        checked={formik.values.isActive}
        onChange={(e) => formik.setFieldValue("isActive", e.target.checked)}
      />{" "}
      <label htmlFor="isActive">Active</label>
    </div>
    <div>
      <input
        type="checkbox"
        id="confirmFeeBeforeSave"
        checked={formik.values.confirmFeeBeforeSave}
        onChange={(e) =>
          formik.setFieldValue("confirmFeeBeforeSave", e.target.checked)
        }
      />{" "}
      <label htmlFor="confirmFeeBeforeSave">
        Confirm parking fee before save
      </label>
    </div>
  </div>
</div>

                {/* --- FIXED --- */}
                {selectedPriceType === 1 && (
                    <>
                    <div className="field col-12 md:col-6">
                        <label><b>Parking Fee </b></label>
                        <span style={{ color: "red" }}>*</span>
                        <InputText
                        name="parkingFee"
                        value={formik.values.parkingFee}
                        onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("parkingFee", value);
    }}
                        placeholder="Enter Parking Fee"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label><b>Receive Fee At</b></label>
                        <div>
                        <label className="mr-3">
                            <input
                            type="radio"
                            name="receivedAtCheckin"
                            checked={formik.values.receivedAtCheckin === true}
                            onChange={() =>
                                formik.setFieldValue("receivedAtCheckin", true)
                            }
                            />{" "}
                            Check-in
                        </label>
                        <label>
                            <input
                            type="radio"
                            name="receivedAtCheckin"
                            checked={formik.values.receivedAtCheckin === false}
                            onChange={() =>
                                formik.setFieldValue("receivedAtCheckin", false)
                            }
                            />{" "}
                            Check-out
                        </label>
                        </div>
                    </div>
                    </>
                )}

                {/* --- HOURLY --- */}
            {/* --- HOURLY --- */}
    {selectedPriceType === 2 && (
    <>
        {/* Setup Selection */}
        <div className="field col-12">
        <label><b>Select Setup</b></label>
        <div>
            <label className="mr-3">
            <input
                type="radio"
                name="hourlySetup"
                value="setup1"
                checked={formik.values.hourlySetup === "setup1"}
                onChange={(e) => formik.setFieldValue("hourlySetup", e.target.value)}
            />{" "}
            Setup 1
            </label>
            <label>
            <input
                type="radio"
                name="hourlySetup"
                value="setup2"
                checked={formik.values.hourlySetup === "setup2"}
                onChange={(e) => formik.setFieldValue("hourlySetup", e.target.value)}
            />{" "}
            Setup 2
            </label>
        </div>
        </div>

    {/* 🧱 SETUP 1 FIELDS */}
{formik.values.hourlySetup === "setup1" && (
  <>
    <div className="field col-12 md:col-4">
      <label><b>Parking Fee </b></label>
      <span style={{ color: "red" }}>*</span>
      <InputText
        name="parkingFee"
        value={formik.values.parkingFee}
        onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("parkingFee", value);
    }}
    
        placeholder="Enter Parking Fee"
      />
    </div>

    <div className="field col-12 md:col-4">
      <label><b>Parking Hour </b></label>
      <span style={{ color: "red" }}>*</span>
      <InputText
        name="parkingHours"
        value={formik.values.parkingHours}
        onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("parkingHours", value);
    }}
        placeholder="Enter Parking Hour"
      />
    </div>

    <div className="field col-12 md:col-4">
      <label><b>Receive Fee At </b></label>
      <span style={{ color: "red" }}>*</span>
      <div>
        <label>
          <input
            type="radio"
            name="receivedAtCheckinEveryHour"
            checked={true}
            onChange={() =>
              formik.setFieldValue("receivedAtCheckinEveryHour", false)
            }
          />{" "}
          Check-out
        </label>
      </div>
    </div>
  </>
)}


        {/* 🧱 SETUP 2 FIELDS */}
        {formik.values.hourlySetup === "setup2" && (
        <>
            {/* Initial Fee */}
            <div className="field col-12 md:col-4">
            <label><b>Initial Fee </b></label>
            <span style={{ color: "red" }}>*</span>
            <InputText
                name="initialFee"
                value={formik.values.initialFee}
                onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("initialFee", value);
    }}
                placeholder="Enter Initial Fee"
            />
            </div>

            <div className="field col-12 md:col-4">
            <label><b>Initial Hours </b></label>
            <span style={{ color: "red" }}>*</span>
            <InputText
                name="initialHours"
                value={formik.values.initialHours}
                onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("initialHours", value);
    }}
                placeholder="Enter Initial Hours"
            />
            </div>

            <div className="field col-12 md:col-4">
            <label><b>Receive Fee At </b></label>
            <span style={{ color: "red" }}>*</span>
            <div>
            
                <label>
                <input
                    type="radio"
                    name="initialReceivedAtCheckin"
                    checked={formik.values.initialReceivedAtCheckin === false}
                    onChange={() => formik.setFieldValue("initialReceivedAtCheckin", false)}
                />{" "}
                Check-out
                </label>
            </div>
            </div>

            {/* Recursive Fee */}
            <div className="field col-12 md:col-4">
            <label><b>Recursive Fee </b></label>
            <span style={{ color: "red" }}>*</span>
            <InputText
                name="recursiveFee"
                value={formik.values.recursiveFee}
                onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("recursiveFee", value);
    }}
                placeholder="Enter Recursive Fee"
            />
            </div>

            <div className="field col-12 md:col-4">
            <label><b>Recursive Hours </b></label>
            <span style={{ color: "red" }}>*</span>
            <InputText
                name="recursiveHours"
                value={formik.values.recursiveHours}
                onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("recursiveHours", value);
    }}
                placeholder="Enter Recursive Hours"
            />
            </div>

            <div className="field col-12 md:col-4">
            <label><b>Receive Fee At *</b></label>
            <div>
            
                <label>
                <input
                    type="radio"
                    name="recursiveReceivedAtCheckin"
                    checked={formik.values.recursiveReceivedAtCheckin === false}
                    onChange={() => formik.setFieldValue("recursiveReceivedAtCheckin", false)}
                />{" "}
                Check-out
                </label>
            </div>
            </div>
        </>
        )}
    </>
    )}

                {/* --- DAILY / MONTHLY --- */}
                {(selectedPriceType === 3 || selectedPriceType === 4) && (
                    <>
                    <div className="field col-12 md:col-6">
                        <label><b>Parking Fee </b></label>
                        <span style={{ color: "red" }}>*</span>
                        <InputText
                        name="parkingFee"
                        value={formik.values.parkingFee}
                        onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // sirf numbers allow
        formik.setFieldValue("parkingFee", value);
    }}
                        placeholder="Enter Parking Fee"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label><b>Receive Fee At</b></label>
                        <div>
                      
                        <label>
                            <input
                            type="radio"
                            name="receivedAtCheckin"
                            checked={formik.values.receivedAtCheckin === false}
                            onChange={() =>
                                formik.setFieldValue("receivedAtCheckin", false)
                            }
                            />{" "}
                            Check-out
                        </label>
                        </div>
                    </div>
                    </>
                )}
                </div>

                {/* Buttons */}
                <div className="col-12 text-right">
                <Button
                    label="Cancel"
                    className="Cancel__button mr-3"
                    type="button"
                    onClick={onHide}
                />
                <Button
                    disabled={disable}
                    type="submit"
                    className="Save__Button"
                     label={isEdit ? "Update" : "Save"}
                />
                </div>
            </div>
            </form>
        </div>
        </>
    );
    };

    export default AddEditPrice;
